function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic_arrow");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "filter-1"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.798800 0 0 0 0 0.798800 0 0 0 0 0.798800 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, React.createElement("g", {
  id: "Bars/Action-List-Bar",
  transform: "translate(-356.000000, -29.000000)"
}, React.createElement("g", {
  id: "Action-List-Bar"
}, React.createElement("g", {
  id: "Button",
  transform: "translate(0.000000, 10.000000)"
}, React.createElement("g", {
  filter: "url(#filter-1)",
  id: "ic_arrow"
}, React.createElement("g", {
  transform: "translate(357.000000, 20.000000)"
}, React.createElement("line", {
  x1: 5.01052632,
  y1: 3.87368421,
  x2: 0.189473684,
  y2: 7.57894737,
  id: "Line-2",
  stroke: "#777777",
  strokeWidth: 2
}), React.createElement("line", {
  x1: 0.189473684,
  y1: 0.168421053,
  x2: 5.01052632,
  y2: 3.87368421,
  id: "Line-2",
  stroke: "#777777",
  strokeWidth: 2
})))))));

var SvgIcArrow = function SvgIcArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "8px",
    height: "10px",
    viewBox: "0 0 8 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_arrow.19e838a0.svg";
export { ForwardRef as ReactComponent };